<template>
  <div class="relative aspect-video">
    <iframe
      title="Canto iFrame"
      src="https://zuerich.canto.de/v/public/"
      loading="lazy"
      aria-label="Canto Widget"
      scrolling="no"
      frameborder="0"
      allowfullscreen
      sandbox="allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups"
      class="mx-auto h-screen w-[var(--container-width)] max-w-screen-fourk desktop:mx-auto desktop:w-full desktop:min-w-[1280px]"
    />
  </div>
</template>
